import { AlmeIvaTypeProp } from "./models/AlmeIvaTypeMapping";

const indexConfig = {
    embeddedIvaRootId: 'alme-ui-embedded-root',
    popupIvaRootId: 'alme-ui-popup-root',
    inlineIvaRootId: 'alme-ui-client-root',
    testPageRootId: 'alme-ui-test-page-root',
    ivaProDivId: 'verint-iva-ui-root',
};

export function getRootIdByIvaType(ivaType?: AlmeIvaTypeProp): string {
    switch (ivaType) {
        case 'popup':
            return indexConfig.popupIvaRootId;
        case 'inline':
            return indexConfig.inlineIvaRootId;
        case 'embedded':
        default:
            return indexConfig.embeddedIvaRootId;
    }

}

export default indexConfig;